import usePage from '../../hooks/usePage';
import useWindowSize from '../../hooks/useWindowSize';
import { getComponentFromName } from '../../lib/utils';

import * as Components from '../displays/display-logins';

function DisplaysPage() {
    const { page } = usePage();
    const { component = null } = (page as DisplaysPage) || {};
    const { width, height } = useWindowSize();
    const Component = getComponentFromName(Components, component, 'Displays') || null;
    return Component !== null ? <Component page={page} vertical={height > width} /> : null;
}

export default DisplaysPage;
